<template>
    <div>
        <v-modal v-if="!!show" :show="true" @close="closeModal">
            <p slot='header'> Вызов завершен </p>
            <div slot="body" class="buttons_list">
                <v-button class="button button_size_ex-large button_color_black" @click='clickButton(btn)' v-for="(btn, index) in buttons"
                    :key="index"
                    :disabled="isloading"
                >
                    {{ btn.name }}
                </v-button>
            </div>
            <!-- <div slot="footer" class="flex-right">
                <button class="button button_size_ex-large button_color_white" @click='handleReset'>Закрыть</button>
                <button class="button button_size_ex-large button_color_black" @click="handleApply(call)">Перейти</button>
            </div>  -->
        </v-modal>
    </div>
</template>

<script>
import vModal from '@components/global/Modal';
import vButton from '@components/global/vButton'
import { eventBus } from '@eventBus'

import api from '@api';
export default {
    name: 'EndCallModal',
    props:{
        callparams: {
            type: Object,
            default: () => {}
        }
    },
    components: {
        vModal,
        vButton
    },
    data(){
        return {
            show: false,
            buttons: false,
            isloading: true,
        }
    },
    mounted() {
        this.uuid = this.callparams.uuid
        this.external_call_id = this.callparams.external_call_id
        this.getRef().then(res=>{
            this.buttons = res.category_list
            this.show = true
        })
    },
    methods: {
        closeModal() {
            this.$emit('close');
        },
        getRef() {
            this.isloading = true
            return api.communications.reference().then(response=>{
                return response
            }).catch(error=>{
                if(error.message) this.$toast.error(error.message)
                console.error(error)
            }).finally(e=>{
                this.isloading = false
            })
        },
        post(category_id) {
            this.isloading = true
            const paylaod = {
                external_call_id: this.external_call_id || 'null',
                category_id,
                uuid: this.uuid
            } 
            return api.chat.chooseCategory(paylaod,'','post').then(response=>{
                return response
            }).catch(error=>{
                if(error.message) this.$toast.error(error.message)
                console.error(error)
            }).finally(e=>{
                this.isloading = false
            })
        },
        clickButton(button) {
            this.post(button.id).then(response=>{
                this.$toast.success(response.message)
                this.closeModal()
            })
        }
    }
}
</script>

<style lang="scss">
    .buttons_list{
        display: block;
        min-width: 500px;
        .button {
            width: 100%;
            margin-bottom: 10px;
        }
    }
</style>